async function request(path) {
  const response = await fetch(path, { credentials: 'include' });
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }
  return response.json();
}

export const i18nApi = {
  getLanguages: () => request('/api/i18n/languages'),
  getTranslations: (lang) => request(`/api/i18n/translations/${lang}`),
  // 0.36.225 — IANA timezone library (431 zones, sorted by offset).
  getTimezones: () => request('/api/i18n/timezones'),
};
